'use client';
//layout.js

import '@/globals.css';
import 'react-datepicker/dist/react-datepicker.css';
import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';
import smartlookClient from 'smartlook-client';
import { SessionProvider } from 'next-auth/react';

export const titles = {
  '/panel/orders/create'            : 'Create new order               | Exodo Panel ',
  '/panel/orders/read/page'         : 'Orders list               | Exodo Panel ',
  'panel/orders/export'             : 'Export orders               | Exodo Panel ',
  '/panel/orders/create'            : 'Create order               | Exodo Panel ',
  '/panel/orders/create'            : 'Create order               | Exodo Panel ',
  '/panel/orders/create'            : 'Create order               | Exodo Panel ',
  '/panel/lms/adsRules'            : 'Ads Rules                  | Affland.id ',
  '/panel/lms/leads'               : 'Leads Live                  | Affland.id ',
  '/panel/lms/orders'              : 'Orders                       | Exodo Panel ',
  '/panel/lms/ordersAdmin'         : 'Admin Dashboard              | Exodo Panel ',
  '/panel/lms/ordersAgent'         : 'Agent Dashboard              | Exodo Panel ',
  '/panel/lms/ordersAgent2'        : 'Agent Dashboard 2            | Exodo Panel ',
  '/panel/lms/ordersTeamLeader'    : 'Team Leader Dashboard        | Exodo Panel ',
  '/panel/lms/ordersValidation'    : 'Validation Dashboard         | Exodo Panel ',
  '/panel/lms/products'            : 'Products Management          | Exodo Panel ',
  '/panel/lms/products/add'        : 'Add Product               | Exodo Panel ',
  '/panel/lms/products/details'    : 'Product Details           | Affland.id ',
  '/panel/lms/products/list'       : 'Payout Partner            | Affland.id ',
  '/panel/lms/leads/postbackList'  : 'Postback List             | Affland.id ',
  '/panel/lms/adsRules'            : 'Ads Rules                 | Affland.id ',
  '/panel/lms/products/offers'     : 'Product Offers            | Affland.id ',
  '/panel/lms/products/payout'     : 'Payout Admin - All Payouts      | Affland.id ',
  '/panel/lms/utils/classifiers'   : 'Classifiers Management          | Affland.id ',
  '/panel/lms/products/statistics' : 'Product Statistics       | Exodo Panel ',
  '/panel/lms/users'              : 'Users Management          | Exodo Panel ',
  '/panel/lms/users/edit'         : 'Edit User                 | Exodo Panel ',
  '/panel/lms/users/profile'      : 'User Profile              | Exodo Panel ',
  '/panel/lms/utils'              : 'Utilities                 | Exodo Panel ',
  '/panel/lms/utils/exchangeRate' : 'Exchange Rate             | Exodo Panel ',
  '/panel/orders/read/page'            : 'Orders               | Exodo Panel '
};

export default function RootLayout({ children }) {
  const pathname = usePathname();
  const [ state, setState ] = useState({
    title: "Exodo Affland"
  });

  const updateState = newState => 
    setState(
        prevState => ({
            ...prevState,
            ...newState
        })
    );
  
  useEffect(() => {
    const pathnameWithtNumb = pathname.replace(/\/\d+/g, '');
    const title = titles[pathnameWithtNumb] || "Exodo Affland";
    updateState({ title });
  }, [pathname]);

  return (
    <html 
      lang="pl" 
      className="h-full bg-gray-50 overflow-x-hidden"
      style={
        pathname === '/' 
          ? { 
              backgroundImage: 'url(exodopanel-background.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            } 
          : {}
      }
    >
      <head>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-280R8WJCDR"></script>
        <script dangerouslySetInnerHTML={{ __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-280R8WJCDR');
        ` }} />
      </head>
      <body>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
        <link rel="manifest" href="/site.webmanifest"/>
        
        <meta name="msapplication-TileColor" content="#da532c"/>
        <meta name="theme-color" content="#ffffff"/>
        <title>{state?.title}</title>

        <SessionProvider>
          {children}
        </SessionProvider>
      </body>
    </html>
  );
}
